import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import LeagueChatContent from 'pages/Events/League/Chats/LeagueChatContent'
import { eventShatStore } from 'state/event/eventChat'
import { leagueEventStore } from 'state/league/leagueEvent'
import { Person } from 'types/globalTypes'

interface ContactParentsModalProps {
  participants: Person[]
}

const ContactParentsModal: React.FC<ContactParentsModalProps> = ({ participants }) => {
  const { form, handleSubmit } = useFormSubmit()

  const { chatModalVisible, setChatModalVisible } = eventShatStore(store => ({
    chatModalVisible: store.chatModalVisible,
    setChatModalVisible: store.setChatModalVisible,
  }))

  const { leagueData } = leagueEventStore(store => ({ leagueData: store.leagueData }))
  const leagueId: string = (leagueData as any)?._id || ''

  if (!chatModalVisible) return null

  return (
    <CustomModal
      openModal={chatModalVisible}
      closeModal={setChatModalVisible}
      title="Contact parents"
      footer={
        <CustomModalFooter
          multibutton={true}
          btnAlignment="justify-end"
          btnText="Cancel,Send"
          onSubmit={handleSubmit}
          closeModal={setChatModalVisible}
        />
      }
    >
      <LeagueChatContent
        form={form}
        leagueId={leagueId}
        participants={participants}
      />
    </CustomModal>
  )
}

export default ContactParentsModal
